import React, { useState, useEffect } from 'react';
import { Segmented, Space, Popover, Row, Menu, Typography } from 'antd';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import {
  ZoomOutMapRounded, UnfoldMoreRounded, CachedRounded, CalendarMonthOutlined, CameraEnhanceRounded,
  MoreVertRounded, CloseRounded
} from "@mui/icons-material";
import DateRange from '../../Components/DateRange';
import dayjs from "dayjs";
const ButtonIcon = ({label}) => {
  switch(label) {
    case '1Y':
    case '3Y':
    case '5Y':
      return null;
    case 'Max':
      return <CachedRounded />;
    case 'Fullscreen':
      return <ZoomOutMapRounded/>;
    default:
      return null;
  }
}

const RangeSelector = ({ years, globalMin, globalMax, onYearSelected, selectedRange, onScreenshot, extra }) => {
  const [selectedOption, setSelectedOption] = useState('max');
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1200);
  const [isXlScreen, setIsXlScreen] = useState(window.innerWidth >= 1600);
  const [showDateRange, setShowDateRange] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsXlScreen(window.innerWidth >= 1600);
      setIsLargeScreen(window.innerWidth >= 1320);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSelection = (value) => {
    setSelectedOption(value);
    let start, end;
    switch (value) {
      case '1_y':
        start = new Date(new Date().setFullYear(new Date().getFullYear() - 1));
        start.setDate(start.getDate() - 1); // Subtract one additional day
        end = new Date();
        break;
      case '3_y':
        start = new Date(new Date().setFullYear(new Date().getFullYear() - 3));
        start.setDate(start.getDate() - 1); // Subtract one additional day
        end = new Date();
        break;
      case '5_y':
        start = new Date(new Date().setFullYear(new Date().getFullYear() - 5));
        start.setDate(start.getDate() - 1); // Subtract one additional day
        end = new Date();
        break;
      case 'max':
        start = new Date(globalMin);
        end = new Date(globalMax);
        break;
      default:
        start = new Date(value-1, 11, 29);
        end = new Date(value, 11, 31);
        break;
    }
    onYearSelected({start: start.getTime(), end: end.getTime()});
  };

  const options = [
    { label: 'Max', value: 'max', variant: 'text' },
    { label: '1 Year', value: '1_y', variant: 'text' },
    { label: '3 Year', value: '3_y', variant: 'text' },
    { label: '5 Year', value: '5_y', variant: 'text' },
  ];

  const popoverContent = (
    <Segmented
      options={options}
      value={selectedOption}
      onChange={(value) => {
        handleSelection(value);
      }}
    />
  );

  const menu = (
    <Menu onClick={(e) => handleSelection(e.key)}>
      {years.map(year => (
        <Menu.Item key={year} style={{borderBottom: '1px solid #ddd', padding: '0px 10px', margin: 0}}>
          {year}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Row justify={'space-between'}>
      <Space>
                {isXlScreen ? (
          <ButtonGroup
            size={'small'}
            color={'inherit'}
            exclusive
            variant={'outlined'}
            value={selectedOption}
          >
            {!showDateRange && selectedRange.start && selectedRange.end ? (
                <Button size={'small'} color={'primary'} variant={'contained'} onClick={()=>setShowDateRange(true)}>
                  {new Intl.DateTimeFormat('en-US', 'yyyy-mm-dd').format(selectedRange.start)} - {new Intl.DateTimeFormat('en-US', 'yyyy-mm-dd').format(selectedRange.end)}
                </Button>
            ) : null}
            {showDateRange && (
                <Space>
                  <Button size={'small'} variant={'text'} color={'error'} onClick={()=>setShowDateRange(false)}>
                    <CloseRounded/>
                  </Button>
                  <DateRange
                    className={'small'}
                    startDate={selectedRange.start }
                    endDate={selectedRange.end}
                    minDate={globalMin}
                    maxDate={globalMax}
                    onDateRangeChange={(start, end) => onYearSelected({start, end})}
                  />
                </Space>
            )}
            {options.map(option => (
              <Button
                onClick={() => handleSelection(option.value)}
                startIcon={<ButtonIcon label={option.label}/>}
                key={option.value} value={option.value}
                variant={option.variant}
                sx={{borderTop: '0'}}
              >
                <Typography.Text strong>{option.label}</Typography.Text>
              </Button>
            ))}
            <Popover
              content={menu}
              title="Select Year"
              trigger="hover"
            >
              <Button size={'small'} variant={'contained'} color={'primary'} startIcon={<UnfoldMoreRounded/>}>Year</Button>
            </Popover>
          </ButtonGroup>
        ) : (
          <Popover content={popoverContent} title="Select Year" trigger="hover">
            <Button variant={'contained'} color={'primary'} size={'small'}>Select a Year</Button>
          </Popover>
        )}

      </Space>
      <Space>
        {isLargeScreen ? extra : (
          <Popover content={extra} title="Additional Options" trigger="hover">
            <Button size={'small'} startIcon={<MoreVertRounded/>} variant={'contained'} color={'primary'}>Chart Tools</Button>
          </Popover>
        )}


        {onScreenshot && (
          <Button onClick={onScreenshot} icon={<CameraEnhanceRounded/>}/>
        )}
      </Space>
    </Row>
  );
};

export default RangeSelector;
